import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=184ae89c&scoped=true&"
import script from "./Relatorio.vue?vue&type=script&lang=js&"
export * from "./Relatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ae89c",
  null
  
)

export default component.exports